<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="1400"
    @keydown.esc="closeButtonClickEvent"
    @close="closeButtonClickEvent"
  >
    <v-card flat>
      <v-toolbar flat>
        <v-toolbar-title>紐付け保守</v-toolbar-title>
      </v-toolbar>
      <v-divider />
      <v-card-text style="max-height: 75vh;overflow-y: auto;" class="pt-3">
        <v-row>
          <v-col>
            <v-expansion-panels
              v-model="panel"
            >
              <v-expansion-panel>
                <v-expansion-panel-header class="panel-header-color panel-selectable">
                  <strong>
                    <v-icon class="panel-header-color">
                      mdi-magnify
                    </v-icon>
                    &nbsp;条件を指定して検索
                  </strong>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card flat>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-select
                            v-model="forms.disposal_category_codes"
                            :items="afterDisposalItemCategories"
                            class="search-font"
                            clearable
                            dense
                            item-text="text"
                            item-value="value"
                            label="処理後物の大分類名称"
                            multiple
                            hide-details="auto"
                            persistent-placeholder
                            rounded
                            outlined
                            @change="afterDisposalItemCategoryChange"
                          >
                            <template v-slot:item="{ item, on, attrs }">
                              <v-list-item
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-list-item-action
                                >
                                  <v-simple-checkbox
                                    :value="isCategorySelected(item)"
                                    :input-value="isCategorySelected(item)"
                                    @click="categoryClick(item)"
                                  />
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <v-chip
                                      small
                                      :color="item.after_type === 'after_industrial' ? 'light-blue lighten-4' : 'light-green lighten-4'"
                                    >
                                      {{ item.after_type === 'after_industrial' ? '廃棄物' : '再資源' }}
                                    </v-chip>
                                    <span class="ml-3">{{ item.text }}</span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>

                          </v-select>
                        </v-col>

                        <v-col cols="12" md="6">
                          <v-select
                            v-model="forms.disposal_subcategory_ids"
                            :items="afterDisposalItemSubcategories"
                            class="search-font"
                            clearable
                            dense
                            item-text="text"
                            item-value="value"
                            label="処理後物の種類"
                            multiple
                            hide-details="auto"
                            persistent-placeholder
                            rounded
                            outlined
                            @change="searchButtonClickEvent"
                            @click:clear="clearAfterDisposalItemSubCategories"
                          >
                            <template v-slot:item="{ item, on, attrs }">
                              <v-list-item
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-list-item-action
                                >
                                  <v-simple-checkbox
                                    :value="isSubSelected(item)"
                                    :input-value="isSubSelected(item)"
                                    @click="subcategoryClick(item)"
                                  />
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ item.code }}:{{ item.text }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col cols="12" md="8">
                          <item-autocomplete
                            v-model="forms.itemId"
                            :items="items"
                            classes="search-font"
                            clearable
                            dense
                            label="JWNET取扱品目"
                            persistent-placeholder
                            outlined
                            rounded
                            multiple
                            chips
                            small-chips
                            deletable-chips
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-select
                            v-model="forms.manifestType"
                            :items="manifestTypes"
                            clearable
                            background-color="white"
                            dense
                            hide-details="auto"
                            label="マニフェスト区分"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" md="3">
                          <cs-date-picker
                            :date.sync="forms.collectedStartDate"
                            @dateChangedCallback="collectedStartDateChangedCallback"
                          >
                            <template v-slot="{ on, attrs }">
                              <v-text-field
                                v-model="forms.collectedStartDate"
                                v-bind="attrs"
                                v-on="on"
                                append-icon="mdi-calendar"
                                clearable
                                dense
                                hide-details="auto"
                                label="引渡し日"
                                outlined
                                persistent-placeholder
                                placeholder="日付を選択"
                                readonly
                                rounded
                                style="font-size: 80%"
                                @click:clear="forms.collectedStartDate = null; searchButtonClickEvent()"
                              >
                                <template v-slot:append-outer>
                                  <div
                                    v-if="$vuetify.breakpoint.mdAndUp"
                                    style="vertical-align: middle"
                                  >
                                    〜
                                  </div>
                                </template>
                              </v-text-field>
                            </template>
                          </cs-date-picker>
                        </v-col>
                        <v-col cols="12" md="3">
                          <cs-date-picker
                            :date.sync="forms.collectedEndDate"
                            @dateChangedCallback="collectedEndDateChangedCallback"
                          >
                            <template v-slot="{ on, attrs }">
                              <v-text-field
                                v-model="forms.collectedEndDate"
                                v-bind="attrs"
                                v-on="on"
                                append-icon="mdi-calendar"
                                clearable
                                dense
                                hide-details="auto"
                                label="終了日"
                                outlined
                                persistent-placeholder
                                placeholder="日付を選択"
                                readonly
                                rounded
                                style="font-size: 80%"
                                @click:clear="forms.collectedEndDate = null; searchButtonClickEvent()"
                              />
                            </template>
                          </cs-date-picker>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-select
                            v-model="forms.recycling"
                            :items="recyclingTypes"
                            dense
                            hide-details="auto"
                            label="リサイクル希望"
                            clearable
                            outlined
                            persistent-placeholder
                            rounded
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="forms.manifestIds"
                            dense
                            hide-details="auto"
                            label="DXEマニ番号(1次)"
                            clearable
                            outlined
                            persistent-hint
                            persistent-placeholder
                            rounded
                            placeholder="カンマ区切りで入力"
                            hint="例: 1, 2, 3"
                            style="font-size: 80%"
                            @blur="searchButtonClickEvent()"
                            @click:clear="forms.manifestIds = null; searchButtonClickEvent()"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col cols="12" md="3">
                          <cs-date-picker
                            :date.sync="forms.disposalCompletedDateFrom"
                            @dateChangedCallback="disposalCompletedDateFromChangedCallback"
                          >
                            <template v-slot="{ on, attrs }">
                              <v-text-field
                                v-model="forms.disposalCompletedDateFrom"
                                v-bind="attrs"
                                v-on="on"
                                append-icon="mdi-calendar"
                                clearable
                                dense
                                hide-details="auto"
                                label="処分終了日 (from)"
                                outlined
                                persistent-placeholder
                                placeholder="日付を選択"
                                readonly
                                rounded
                                style="font-size: 80%"
                                @click:clear="forms.disposalCompletedDateFrom = null; searchButtonClickEvent()"
                              >
                                <template v-slot:append-outer>
                                  <div
                                    v-if="$vuetify.breakpoint.mdAndUp"
                                    style="vertical-align: middle"
                                  >
                                    〜
                                  </div>
                                </template>
                              </v-text-field>
                            </template>
                          </cs-date-picker>
                        </v-col>
                        <v-col cols="12" md="3">
                          <cs-date-picker
                            :date.sync="forms.disposalCompletedDateTo"
                            @dateChangedCallback="disposalCompletedDateToChangedCallback"
                          >
                            <template v-slot="{ on, attrs }">
                              <v-text-field
                                v-model="forms.disposalCompletedDateTo"
                                v-bind="attrs"
                                v-on="on"
                                append-icon="mdi-calendar"
                                clearable
                                dense
                                hide-details="auto"
                                label="処分終了日 (to)"
                                outlined
                                persistent-placeholder
                                placeholder="日付を選択"
                                readonly
                                rounded
                                style="font-size: 80%"
                               @click:clear="forms.disposalCompletedDateTo = null; searchButtonClickEvent()"
                              />
                            </template>
                          </cs-date-picker>
                        </v-col>
                        <v-col cols="12" md="3">
                          <v-select
                            v-model="forms.disposalMethodIds"
                            :items="disposalMethods"
                            clearable
                            dense
                            hide-details="auto"
                            label="処分方法"
                            outlined
                            persistent-placeholder
                            rounded
                            multiple
                            style="font-size: 90%;"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>
                        <v-col cols="12" md="2">
                          <v-text-field
                            v-model="forms.wasteName"
                            background-color="white"
                            dense
                            hide-details="auto"
                            label="廃棄物の名称"
                            outlined
                            rounded
                            persistent-placeholder
                            clearable
                            style="font-size: 80%"
                            @blur="searchButtonClickEvent()"
                            @click:clear="forms.wasteName = null; searchButtonClickEvent()"
                          />
                        </v-col>
                      </v-row>

                      <v-row dense v-if="isJwmode">
                        <v-col v-if="customLabel.custom_labels1_use" cols="12" md="2" >
                          <v-text-field
                            v-model="forms.customLabels1"
                            dense
                            hide-details="auto"
                            :label="customLabel.custom_labels1_name"
                            :disabled="(forms.customLabels1Unregistered)"
                            clearable
                            outlined
                            persistent-placeholder
                            rounded
                            @blur="searchButtonClickEvent()"
                            @click:clear="searchForm.customLabels1 = null; searchButtonClickEvent()"
                          >
                          </v-text-field>
                        </v-col>

                        <v-col v-if="customLabel.custom_labels2_use" cols="12" md="2">
                          <v-text-field
                            v-model="forms.customLabels2"
                            dense
                            hide-details="auto"
                            :label="customLabel.custom_labels2_name"
                            :disabled="(forms.customLabels2Unregistered)"
                            clearable
                            outlined
                            persistent-placeholder
                            rounded
                            @blur="searchButtonClickEvent()"
                            @click:clear="searchForm.customLabels2 = null; searchButtonClickEvent()"
                          >
                          </v-text-field>
                        </v-col>

                        <v-col v-if="customLabel.custom_labels3_use" cols="12" md="2">
                          <v-text-field
                            v-model="forms.customLabels3"
                            dense
                            hide-details="auto"
                            :label="customLabel.custom_labels3_name"
                            :disabled="(forms.customLabels3Unregistered)"
                            clearable
                            outlined
                            persistent-placeholder
                            rounded
                            @blur="searchButtonClickEvent()"
                            @click:clear="searchForm.customLabels3 = null; searchButtonClickEvent()"
                          >
                          </v-text-field>
                        </v-col>

                        <v-col v-if="customLabel.custom_labels4_use" cols="12" md="2">
                          <v-text-field
                            v-model="forms.customLabels4"
                            dense
                            hide-details="auto"
                            :label="customLabel.custom_labels4_name"
                            :disabled="(forms.customLabels4Unregistered)"
                            clearable
                            outlined
                            persistent-placeholder
                            rounded
                            @blur="searchButtonClickEvent()"
                            @click:clear="searchForm.customLabels4 = null; searchButtonClickEvent()"
                          >
                          </v-text-field>
                        </v-col>

                        <v-col v-if="customLabel.custom_labels5_use" cols="12" md="2">
                          <v-text-field
                            v-model="forms.customLabels5"
                            dense
                            hide-details="auto"
                            :label="customLabel.custom_labels5_name"
                            :disabled="(forms.customLabels5Unregistered)"
                            clearable
                            outlined
                            persistent-placeholder
                            rounded
                            @blur="searchButtonClickEvent()"
                            @click:clear="searchForm.customLabels5 = null; searchButtonClickEvent()"
                          >
                          </v-text-field>
                        </v-col>

                        <v-col v-if="customLabel.custom_labels6_use" cols="12" md="2">
                          <v-text-field
                            v-model="forms.customLabels6"
                            dense
                            hide-details="auto"
                            :label="customLabel.custom_labels6_name"
                            :disabled="(forms.customLabels6Unregistered)"
                            clearable
                            outlined
                            persistent-placeholder
                            rounded
                            @blur="searchButtonClickEvent()"
                            @click:clear="searchForm.customLabels6 = null; searchButtonClickEvent()"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row dense v-if="isJwmode">
                        <v-col v-if="customLabel.custom_labels1_use" cols="12" md="2" >
                          <v-checkbox
                            v-model="forms.customLabels1Unregistered"
                            label="未入力データのみ検索"
                            dense
                            hide-details="auto"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>

                        <v-col v-if="customLabel.custom_labels2_use" cols="12" md="2">
                          <v-checkbox
                            v-model="forms.customLabels2Unregistered"
                            label="未入力データのみ検索"
                            dense
                            hide-details="auto"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>

                        <v-col v-if="customLabel.custom_labels3_use" cols="12" md="2">
                          <v-checkbox
                            v-model="forms.customLabels3Unregistered"
                            label="未入力データのみ検索"
                            dense
                            hide-details="auto"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>

                        <v-col v-if="customLabel.custom_labels4_use" cols="12" md="2">
                          <v-checkbox
                            v-model="forms.customLabels4Unregistered"
                            label="未入力データのみ検索"
                            dense
                            hide-details="auto"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>

                        <v-col v-if="customLabel.custom_labels5_use" cols="12" md="2">
                          <v-checkbox
                            v-model="forms.customLabels5Unregistered"
                            label="未入力データのみ検索"
                            dense
                            hide-details="auto"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>

                        <v-col v-if="customLabel.custom_labels6_use" cols="12" md="2">
                          <v-checkbox
                            v-model="forms.customLabels6Unregistered"
                            label="未入力データのみ検索"
                            dense
                            hide-details="auto"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>
                      </v-row>

                      <v-row dense>
                        <v-col cols="12" md="3">
                          <v-text-field
                            v-model="forms.manifestSearchKeyword"
                            background-color="white"
                            dense
                            hide-details="auto"
                            label="マニフェスト検索キーワード"
                            outlined
                            rounded
                            persistent-placeholder
                            clearable
                            style="font-size: 80%"
                            @blur="searchButtonClickEvent()"
                            @click:clear="forms.manifestSearchKeyword = null; searchButtonClickEvent()"
                          />
                        </v-col>

                        <v-col cols="12" md="3">
                          <v-select
                            v-model="forms.sortType"
                            :items="sortTypes"
                            dense
                            hide-details="auto"
                            label="表示順"
                            outlined
                            persistent-placeholder
                            rounded
                            style="font-size: 80%"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>

                        <v-col cols="12" md="3">
                          <v-checkbox
                            v-model="forms.withAssociated"
                            dense
                            class="mt-2"
                            hide-details="auto"
                            label="紐付きのあるマニフェストを含める"
                            @change="searchButtonClickEvent()"
                          />
                        </v-col>

                      </v-row>


                    </v-card-text>
                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="primary"
                        @click="searchButtonClickEvent"
                      >
                        <v-icon>mdi-magnify</v-icon>&nbsp;検索
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </v-col>
        </v-row>

        <v-row dense>
          <v-col>
            <v-card flat>
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="3">
                    <h4 class="mt-3">紐付けされている１次マニフェスト</h4>
                  </v-col>
                  <v-col cols="12" md="9">
                    <custom-pagination
                      :page-number="relatedPage"
                      :per-page="relatedPerPage"
                      :pagination="relatedPagination"
                      :total-visible="totalVisible"
                      :page-options="pageOptions"
                      @pageChanged="relatedPageChangeEvent"
                      @perPageChanged="relatedPerPageChangeEvent"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-data-table
                  :headers="relatedTableHeaders"
                  :items="relatedManifests"
                  :items-per-page="-1"
                  checkbox-color="#DCDCDC"
                  dense
                  hide-default-footer
                  disable-sort
                  show-select
                  @toggle-select-all="relatedSelectedAllCheckboxClickEvent($event)"
                  @click:row="toggleRelatedRowSelection"
                >
                  <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :value="isSelected"
                      @input="select($event)"
                      @click="relatedCheckboxClickEvent(item)"
                    />
                  </template>
                  <!-- マニフェスト番号 -->
                  <template v-slot:[`item.manifest_no`]="{item}">
                    <div>{{ item.manifest_no }}&nbsp;</div>
                    <div>
                      <small class="text--disabled">{{ item.manifest_type | manifest_type_to_label }}</small>
                    </div>
                  </template>
                  <!-- /マニフェスト番号 -->
                  <!-- DXEマニ番号 -->
                  <template v-slot:[`item.manifest_id`]="{item}">
                    <div>{{ item.manifest_id }}&nbsp;</div>
                  </template>
                  <!-- /DXEマニ番号 -->
                  <!-- 回収日 -->
                  <template v-slot:[`item.collected_date`]="{ item }">
                    <small>
                      <span
                        v-if="item.past_manifest"
                        style="color:#3CBF91"
                      >
                        ●
                      </span>
                      {{ item.collected_date | date_format }}
                    </small>
                  </template>
                  <!-- /回収日 -->
                  <!-- 排出事業者 -->
                  <template v-slot:[`item.emission`]="{ item }">
                    <small class="line-clamp one-clamp">
                      {{ item.emission.name }}
                      <v-icon
                        v-if="item.use_recycle"
                        class="green--text"
                      >
                        mdi-recycle
                      </v-icon>
                      <v-tooltip
                        top
                        :open-on-hover="false"
                      >
                        <template #activator="{ on }">
                          <v-btn
                            v-if="item.emission_location.address"
                            icon
                            small
                            retain-focus-on-click
                            @click="on.click"
                            @blur="on.blur"
                          >
                            <v-icon small>
                              mdi-map-marker-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <strong>{{ item.emission_location.name }}</strong>
                        <br />
                        <small
                          v-if="item.emission_location.address"
                        >
                          {{ item.emission_location.address }}
                        </small>
                      </v-tooltip>
                    </small>
                  </template>
                  <!-- /排出事業者 -->
                  <!-- 処分業者 -->
                  <template v-slot:[`item.disposer`]="{ item }">
                    <small class="line-clamp one-clamp">
                      {{ item.disposer.name}}
                      <v-tooltip
                        top
                        :open-on-hover="false"
                      >
                        <template #activator="{ on }">
                          <v-btn
                            icon
                            small
                            retain-focus-on-click
                            @click="on.click"
                            @blur="on.blur"
                          >
                            <v-icon small>
                              mdi-map-marker-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <div>
                          <strong>{{ item.disposer_location.name }}</strong>
                          <br />
                          <small
                            v-if="item.disposer"
                          >
                            {{ item.disposer_location.address }}
                          </small>
                        </div>
                      </v-tooltip>
                    </small>
                  </template>
                  <!-- /処分業者 -->
                  <!-- 品目／荷姿／数量 -->
                  <template v-slot:[`item.waste`]="{ item }">
                    <div>
                      <v-chip
                        :title="item.item_name"
                        color="#F0E6D0"
                        drak
                        label
                        x-small
                      >
                        {{ item.item_name | truncate(10) }}
                      </v-chip>
                    </div>
                    <small>{{ item.packing_name }}</small>&nbsp;
                    <small>{{ item.report_transport_quantity | comma_format }}&nbsp;{{ item.report_transport_quantity_unit_name }}</small>
                  </template>
                  <!-- /品目／荷姿／数量 -->
                  <!-- 処理後物の名称 -->
                  <template v-slot:[`item.after_item`]="{ item }">
                      <small class="line-clamp one-clamp">
                      {{ item.after_item_name }}
                    </small>
                  </template>
                  <!-- /処理後物の名称 -->
                  <!-- 処分終了日/処分方法 -->
                  <template v-slot:[`item.disposal_report_end_date`]="{ item }">
                    <div v-if="item.disposal_report_end_date">
                      {{ item.disposal_report_end_date | date_format }}
                    </div>
                    <div v-else>-</div>
                    {{ item.disposal_method_name }}
                  </template>
                  <!-- /処分終了日/処分方法 -->
                </v-data-table>
              </v-card-text>
              <v-card-text>
                <v-row dense>
                  <v-col>
                    <custom-pagination
                      :page-number="relatedPage"
                      :per-page="relatedPerPage"
                      :pagination="relatedPagination"
                      :total-visible="totalVisible"
                      :page-options="pageOptions"
                      @pageChanged="relatedPageChangeEvent"
                      @perPageChanged="relatedPerPageChangeEvent"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-divider />
          </v-col>
        </v-row>

        <!-- 検索結果一覧 -->
        <v-row dense>
          <v-col>
            <!-- 検索結果一覧 -->
            <v-card flat class="rounded-card">
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="3">
                    <h4 class="mt-3">検索結果</h4>
                  </v-col>
                  <v-col cols="12" md="9">
                    <custom-pagination
                      :page-number="page"
                      :per-page="perPage"
                      :pagination="pagination"
                      :total-visible="totalVisible"
                      :page-options="pageOptions"
                      @pageChanged="pageChangeEvent"
                      @perPageChanged="perPageChangeEvent"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text>
                <v-data-table
                  v-model="rowSelected"
                  :headers="tableHeaders"
                  :items="manifests"
                  :items-per-page="-1"
                  disable-sort
                  hide-default-footer
                  show-select
                  @toggle-select-all="selectedAllCheckboxClickEvent($event)"
                  @click:row="toggleRowSelection"
                >
                  <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
                    <v-simple-checkbox
                      v-model="item.selected"
                      :value="isSelected"
                      :readonly="item.disabled"
                      :disabled="item.disabled"
                      :indeterminate="item.disabled"
                      @input="select($event)"
                      @click="checkboxClickEvent(item)"
                    />
                  </template>
                  <!-- マニフェスト番号 -->
                  <template v-slot:[`item.manifest_no`]="{item}">
                    <div>
                      <span
                        v-if="item.with_parent_manifest"
                        style="color:#3CBF91"
                      >
                        ●
                      </span>{{ item.manifest_no }}&nbsp;
                    </div>
                    <div>
                      <small class="text--disabled">{{ item.manifest_type | manifest_type_to_label }}</small>
                    </div>
                  </template>
                  <!-- /マニフェスト番号 -->
                  <!-- DXEマニ番号 -->
                  <template v-slot:[`item.manifest_id`]="{item}">
                    <div>{{ item.manifest_id }}&nbsp;</div>
                  </template>
                  <!-- /DXEマニ番号 -->
                  <!-- 引渡し日 -->
                  <template v-slot:[`item.collected_date`]="{ item }">
                    <small>
                      <span
                        v-if="item.past_manifest"
                        style="color:#3CBF91"
                      >
                        ●
                      </span>
                      {{ item.collected_date | date_format }}
                    </small>
                  </template>
                  <!-- /引渡し日 -->
                  <!-- 排出事業者-->
                  <template v-slot:[`item.emission`]="{ item }">
                    <small class="line-clamp one-clamp">
                      {{ item.emission.name }}
                      <v-icon
                        v-if="item.use_recycle"
                        class="green--text"
                      >
                        mdi-recycle
                      </v-icon>
                      <v-tooltip
                        top
                        :open-on-hover="false"
                      >
                        <template #activator="{ on }">
                          <v-btn
                            v-if="item.emission_location.address"
                            icon
                            small
                            retain-focus-on-click
                            @click="on.click"
                            @blur="on.blur"
                          >
                            <v-icon small>
                              mdi-map-marker-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <strong>{{ item.emission_location.name }}</strong>
                        <br />
                        <small
                          v-if="item.emission_location.address"
                        >
                          {{ item.emission_location.address }}
                        </small>
                      </v-tooltip>
                    </small>
                  </template>
                  <!-- /排出事業者 -->
                  <!-- 処分業者 -->
                  <template v-slot:[`item.disposer`]="{ item }">
                    <small class="line-clamp one-clamp">
                      {{ item.disposer.name }}
                      <v-tooltip
                        top
                        :open-on-hover="false"
                      >
                        <template #activator="{ on }">
                          <v-btn
                            v-if="item.disposer_location.address"
                            icon
                            small
                            retain-focus-on-click
                            @click="on.click"
                            @blur="on.blur"
                          >
                            <v-icon small>
                              mdi-map-marker-outline
                            </v-icon>
                          </v-btn>
                        </template>
                        <div>
                          <strong>{{ item.disposer_location.name }}</strong>
                          <br />
                          <small
                            v-if="item.disposer_location.address"
                          >
                            {{ item.disposer_location.address }}
                          </small>
                        </div>
                      </v-tooltip>
                    </small>
                  </template>
                  <!-- /運搬先 -->
                  <!-- 品目／荷姿／数量 -->
                  <template v-slot:[`item.waste`]="{ item }">
                    <div>
                      <v-chip
                        :title="item.item_name"
                        color="#F0E6D0"
                        drak
                        label
                        x-small
                      >
                        {{ item.item_name | truncate(10) }}
                      </v-chip>
                    </div>
                    <small>{{ item.packing_name }}</small>&nbsp;
                    <small>{{ item.report_transport_quantity | comma_format }}&nbsp;{{ item.report_transport_quantity_unit_name }}</small>
                  </template>

                  <!-- 処理後物の名称 -->
                  <template v-slot:[`item.after_item`]="{ item }">
                      <small class="line-clamp one-clamp">
                      {{ item.after_item_name }}
                    </small>
                  </template>
                  <!-- /処理後物の名称 -->

                  <!-- 処分終了日/処分方法 -->
                  <template v-slot:[`item.disposal_report_end_date`]="{ item }">
                    <div v-if="item.disposal_report_end_date">
                      {{ item.disposal_report_end_date | date_format }}
                    </div>
                    <div v-else>-</div>
                    {{ item.disposal_method_name }}
                  </template>
                  <!-- /処分終了日/処分方法 -->
                </v-data-table>
              </v-card-text>
              <v-card-text>
                <v-row dense>
                  <v-col>
                    <custom-pagination
                      :page-number="page"
                      :per-page="perPage"
                      :pagination="pagination"
                      :total-visible="totalVisible"
                      :page-options="pageOptions"
                      @pageChanged="pageChangeEvent"
                      @perPageChanged="perPageChangeEvent"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <!-- /検索結果一覧 -->
          </v-col>
        </v-row>
        <!-- /検索結果一覧 -->

        <!-- 検索結果 ページャ -->

        <!-- /検索結果 ページャ -->

      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="closeButtonClickEvent"
        >
          閉じる
        </v-btn>
        <v-btn
          :disabled="!isRegister || !relatedLoaded"
          class="primary"
          @click="registerButtonClickEvent"
        >
          登録する
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import ItemAutocomplete from "@/driver/components/ItemAutocomplete.vue";

export default {
  name: 'SelectablePreviouslyManifestDialog',
  components: {
    CustomPagination,
    ItemAutocomplete,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
    targetManifestId: {
      type: Number,
      default: () => null,
    },
    isRegister: {
      type: Boolean,
      default: () => false
    },
    isJwmode: {
      type: Boolean,
      default: () => false
    },
    customLabel: {},
  },
  data() {
    return {
      page: 1,
      perPage: 15,
      totalVisible: 7,
      relatedPage: 1,
      relatedPerPage: 15,
      relatedPageCount: 0,
      panel: [],
      // ページネーションの表示件数選択肢
      pageOptions: [15,30,50,100,200,300],
      afterDisposalItemCategories: [],
      afterDisposalItemSubcategories: [],
      // 紐付き済のマニフェストのロード完了判定
      relatedLoaded: false,
      forms: {
        itemId: null,
        manifestType: null,
        collectedStartDate: null,
        collectedEndDate: null,
        disposal_category_codes: [],
        disposal_subcategory_ids: [],
        recycling: null,
        manifestIds: null,
        disposalCompletedDateFrom: null,
        disposalCompletedDateTo: null,
        disposalMethodIds: null,
        wasteName: null,
        withAssociated: false,
        customLabels1: null,
        customLabels2: null,
        customLabels3: null,
        customLabels4: null,
        customLabels5: null,
        customLabels6: null,
        customLabels1Unregistered: false,
        customLabels2Unregistered: false,
        customLabels3Unregistered: false,
        customLabels4Unregistered: false,
        customLabels5Unregistered: false,
        customLabels6Unregistered: false,
        manifestSearchKeyword: null,
        sortType: 'updated_date_desc',
      },
      relatedTableHeaders: [
        { text: 'マニフェスト番号', value: 'manifest_no', class: 'z-index_zero' },
        { text: 'DXEマニ番号', value: 'manifest_id', class: 'z-index_zero' },
        { text: '引渡し日', value: 'collected_date', class: 'z-index_zero' },
        { text: '排出事業者', value: 'emission', class: 'z-index_zero' },
        { text: '処分業者', value: 'disposer', class: 'z-index_zero' },
        { text: '品目/荷姿/数量', value: 'waste', class: 'z-index_zero' },
        { text: '処理後物の種類', value: 'after_item', class: 'z-index_zero' },
        { text: '処分終了日\r\n処分方法', value: 'disposal_report_end_date', class: 'z-index_zero' },
      ],
      tableHeaders: [
        { text: 'マニフェスト番号', value: 'manifest_no', class: 'z-index_zero' },
        { text: 'DXEマニ番号', value: 'manifest_id', class: 'z-index_zero' },
        { text: '引渡し日', value: 'collected_date', class: 'z-index_zero' },
        { text: '排出事業者', value: 'emission', class: 'z-index_zero' },
        { text: '処分業者', value: 'disposer', class: 'z-index_zero' },
        { text: '品目/荷姿/数量', value: 'waste', class: 'z-index_zero' },
        { text: '処理後物の種類', value: 'after_item', class: 'z-index_zero' },
        { text: '処分終了日\r\n処分方法', value: 'disposal_report_end_date', class: 'z-index_zero' },
      ],
      /** マニフェスト区分 */
      manifestTypes: [
        { value: 'dxe_form', text: '電子マニフェスト(EDI)' },
        { value: 'other_form', text: '電子マニフェスト(WEB)' },
        { value: 'paper_form', text: '紙マニフェスト' },
        { value: 'transfer_form', text: '電子マニフェスト(取込)' }
      ],
      recyclingTypes: [
        { value: 'not_including', text: '含まない'},
        { value: 'request_only', text: 'リサイクル希望のみ'}
      ],
      /** 表示順 */
      sortTypes: [
        { value: 'updated_date_desc', text: '更新日（降順）▼' },
        { value: 'updated_date_asc', text: '更新日（昇順）▲' },
        { value: 'collected_date_desc', text: '引渡し日（降順）▼' },
        { value: 'collected_date_asc', text: '引渡し日（昇順）▲' },
      ],
      /* 検索結果のマニフェストのうち選択されているマニフェストのIDを管理 */
      manifests: [],
      rowSelected: [],
      selectedIds: [],
      removableIds: [],
      items: [],
      disposalMethods: [],

      /* 紐付けされている１次マニフェスト */
      relatedManifests: [],
      relatedPagination: {
        current_page: 1,
        total_count: 0
      },
      pagination: {
        current_page: 1,
        total_count: 0
      },
    }
  },
  computed: {
    ...mapState('DriverManifestPreviously', {
      selectedItems: 'selectedItems',
    }),
    ...mapGetters('DriverManifestPreviously', [
      'selectedMembers',
    ]),
  },
  watch: {
    enableDialog (newValue) {
      this.clearIndividualItem()
      this.page = 1
      this.relatedPage = 1
      this.perPage = 15;
      this.relatedPerPage = 15;
      this.pagination = {}
      this.panel = []
      this.manifests = []
      this.selectedIds = []
      this.relatedManifests = []
      this.relatedLoaded = false
      this.removableIds = []
      this.items = []
      Object.assign(this.$data.forms, this.$options.data().forms)
      Object.assign(this.$data.pagination, this.$options.data().pagination)
      Object.assign(this.$data.relatedPagination, this.$options.data().relatedPagination)
      if (newValue) {
        this.loadAfterDisposalOptions()
        this.fetchItems().then((content) => { this.items = content.items})
        this.fetchDisposalMethods().then((content) => {this.disposalMethods = content.disposal_methods})
        this.searchRelatedManifests()

      }
    },
  },
  created() {

  },
  methods: {
    ...mapActions('DriverManifestPreviously', {
      fetchManifests: 'index',
      setIndividualItem: 'setIndividualItem',
      removeIndividualItem: 'removeIndividualItem',
      removeItem: 'removeItem',
      allRemoveItems: 'allRemoveItems',
      clearIndividualItem: 'clearIndividualItem',
    }),
    ...mapActions('DriverManifestRelation', {
      fetchRelationManifests: 'index',
      updateRelationManifests: 'update'
    }),
    ...mapActions('DriverMasterSearchItem', {
      fetchItems: 'index',
    }),
    /** 処分方法 */
    ...mapActions('DriverMasterSearchDisposalMethod', {
      fetchDisposalMethods: 'index',
    }),

    /**
     * 処理後物の大分類
     */
    ...mapActions("DriverMasterSearchRecycleDisposedItemCategory", {
      fetchDisposalItemCategories: 'index',
    }),

    ...mapActions("DriverMasterSearchRecycleDisposedItemSubcategory", {
      fetchDisposalItemSubcategories: 'index',
    }),

    /**
     * 紐付けされている１次マニフェスト ページチェンジイベント
     */
    relatedPageChangeEvent (page) {
      this.relatedPage = page
      this.searchRelatedManifests()
    },
    relatedPerPageChangeEvent (perPage) {
      this.relatedPerPage = perPage
      this.relatedPage = 1
      this.searchRelatedManifests()
    },
    /**
     * 検索結果 ページチェンジイベント
     */
    pageChangeEvent (page) {
      this.page = page;
      this.searchManifests();
    },
    perPageChangeEvent (perPage) {
      this.perPage = perPage;
      this.page = 1;
      this.searchManifests();
    },
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1
      this.rowSelected = null;
      this.rowSelected = [];
      this.allRemoveItems()
      this.searchManifests()
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    /**
     * 登録するボタン クリックイベント
     */
    registerButtonClickEvent () {

      this.selectedIds = []

      // for (const manifest_id of this.selectedMembers) {
      for (const manifest_key of this.selectedMembers) {
        // this.selectedIds.push(manifest_id)
        this.selectedIds.push(manifest_key)
      }

      let params = {
        manifest_ids: this.selectedIds,
        removable_ids: this.removableIds,
      }

      this.updateRelationManifests({id: this.targetManifestId, params: params}).then(() => {
        this.$emit('registerCallback')
      })
    },
    /**
     *
     */
    searchRelatedManifests () {
      const params = { page: this.relatedPage, limit: this.relatedPerPage }
      this.fetchRelationManifests({id: this.targetManifestId, params: params}).then((content) => {
        // this.relatedManifests = content.manifests
        this.relatedManifests = content.manifest_connections
        // 初期状態で全てチェックON(紐付けされているマニフェストは削除対象外)
        for (const manifest of this.relatedManifests) {
          manifest.selected = true
        }
        /*
         * 2024/11/01 add
         * 展開前に登録ボタンが押せることで紐ついている1次マニがすべて削除されてしまう問題が確認できたため、
         * ロードされたかを判定するフラグを追加し登録ボタンの押下制御を行うように対応
         */
        this.relatedLoaded = true;
        this.relatedPagination = content.pagination
        this.recheckRelatedManifests()
      })
    },
    /**
     * 引渡し日変更　コールバック
     */
    collectedStartDateChangedCallback (value) {
      this.forms.collectedStartDate = value;
      this.searchButtonClickEvent();
    },
    /**
     * 引渡し終了日変更　コールバック
     */
    collectedEndDateChangedCallback (value) {
      this.forms.collectedEndDate = value;
      this.searchButtonClickEvent();
    },
    /**
     * 処分終了日 (from)変更　コールバック
     */
    disposalCompletedDateFromChangedCallback (value) {
      this.forms.disposalCompletedDateFrom = value;
      this.searchButtonClickEvent();
    },
    /**
     * 処分終了日 (to)変更　コールバック
     */
    disposalCompletedDateToChangedCallback (value) {
      this.forms.disposalCompletedDateTo = value;
      this.searchButtonClickEvent();
    },
    // 大分類の選択肢を取得し、続けて種類の選択肢も取得する
    loadAfterDisposalOptions () {
      this.fetchDisposalItemCategories().then((content) => {
        this.afterDisposalItemCategories = content.after_disposal_items || []
        return this.loadDisposedTypeOptions()
      })
    },
    // 選択中の大分類に紐づく種類の選択肢を取得する（大分類未選択時はクリア）
    loadDisposedTypeOptions () {
      if (this.forms.disposal_category_codes.length <= 0) {
        this.afterDisposalItemSubcategories = []
        this.forms.disposal_subcategory_ids = []
        return Promise.resolve()
      }
      this.fetchDisposalItemSubcategories({
        disposal_category_codes: this.forms.disposal_category_codes
      }).then((content) => {
        this.afterDisposalItemSubcategories = content.after_disposal_items || []
      })
    },
    /**
     * 検索の実行
     */
    searchManifests () {
      const params = {
        item_id: this.forms.itemId,
        manifest_type: this.forms.manifestType,
        disposal_category_codes: this.forms.disposal_category_codes,
        disposal_subcategory_ids: this.forms.disposal_subcategory_ids,
        collected_start_date: this.forms.collectedStartDate,
        collected_end_date: this.forms.collectedEndDate,
        manifest_ids: this.forms.manifestIds,
        recycling: this.forms.recycling,
        disposal_completed_date_from: this.forms.disposalCompletedDateFrom,
        disposal_completed_date_to: this.forms.disposalCompletedDateTo,
        disposal_method_ids: this.forms.disposalMethodIds,
        waste_name: this.forms.wasteName,
        with_associated: this.forms.withAssociated,
        custom_labels_1: this.forms.customLabels1,
        custom_labels_2: this.forms.customLabels2,
        custom_labels_3: this.forms.customLabels3,
        custom_labels_4: this.forms.customLabels4,
        custom_labels_5: this.forms.customLabels5,
        custom_labels_6: this.forms.customLabels6,
        custom_labels_1_unregistered: this.forms.customLabels1Unregistered,
        custom_labels_2_unregistered: this.forms.customLabels2Unregistered,
        custom_labels_3_unregistered: this.forms.customLabels3Unregistered,
        custom_labels_4_unregistered: this.forms.customLabels4Unregistered,
        custom_labels_5_unregistered: this.forms.customLabels5Unregistered,
        custom_labels_6_unregistered: this.forms.customLabels6Unregistered,
        manifest_id: this.targetManifestId,
        manifest_search_keyword: this.forms.manifestSearchKeyword,
        sort_type: this.forms.sortType,
        limit: this.perPage,
        page: this.page
      }
      this.fetchManifests({params: params}).then((content) => {
        this.manifests = content.manifests
        this.pagination = content.pagination
        this.recheckManifests()
      })
    },
    /**
     * 紐付けされている１次マニフェスト一覧 行選択トグル
     */
    toggleRelatedRowSelection(item) {
      // チェック状態を反転
      item.selected = !item.selected;

      if (item.selected) {
        // チェックONの場合、削除対象から除外
        this.removableIds = this.removableIds.filter(v => v !== item.id);
      } else {
        // チェックOFFの場合、削除対象に追加
        if (!this.removableIds.includes(item.id)) {
          this.removableIds.push(item.id);
        }
      }
    },
    /**
     * 検索結果一覧 行選択トグル
     */
    toggleRowSelection(item) {
      // disabledな行は選択不可
      if (item.disabled) {
        return;
      }

      const index = this.rowSelected.findIndex(row => row === item);
      if (index > -1) {
        // 既に選択されている場合は削除
        this.rowSelected.splice(index, 1);
        item.selected = false;
        this.removeItem({item: item});
      } else {
        // 選択されていない場合は追加
        this.rowSelected.push(item);
        item.selected = true;
        this.setIndividualItem({item: item});
      }
    },
    /**
     * 紐付けされている１次マニフェスト一覧 チェックボックス クリックイベント
     * チェックが外されたマニフェストIDを保持する.
     * @param item
     */
    relatedCheckboxClickEvent (item) {
      if (item.selected) {
        this.removableIds = this.removableIds.filter( v => v !== item.id)
      } else {
        this.removableIds.push(item.id)
      }
    },
    /**
     * 紐付けされている１次マニフェスト一覧 チェックボックスの一括切替 クリックイベント
     */
    relatedSelectedAllCheckboxClickEvent (selectedItems) {
      let items = selectedItems.items
      let isSelected = selectedItems.value
      if (isSelected) {
        for (let item of items) {
          item.selected = true
          this.removableIds = this.removableIds.filter( v => v !== item.id)
        }
      } else {
        for (let item of items) {
          item.selected = false
          if (!this.removableIds.includes(item.id)) {
            this.removableIds.push(item.id)
          }
        }
      }
    },
    /**
     * 検索結果一覧 チェックボックス クリックイベント
     * 選択されたIDを保持する.
     * @param item
     */
    checkboxClickEvent (item) {
      if (item.selected) {
        if (!item.disabled) {
          this.setIndividualItem({item: item})
        }
      } else {
        if (!item.disabled) {
          this.removeItem({item: item})
        }
      }
    },
    /**
     * チェックボックスの一括切替 クリックイベント
     */
    selectedAllCheckboxClickEvent (selectedItems) {

      let items = selectedItems.items
      let isSelected = selectedItems.value
      if (isSelected) {
        for (let item of items) {
          if (!item.disabled) {
            item.selected = true
            this.setIndividualItem({item: item})
          }
        }
      } else {
        for (let item of items) {
          if (!item.disabled) {
            this.rowSelected = null;
            this.rowSelected = [];
            this.allRemoveItems()
            item.selected = false
          }
        }
      }
    },
    /**
     * 紐付けされている１次マニフェスト一覧の再設定
     */
    recheckRelatedManifests () {
      for (const related_manifest of this.relatedManifests) {
        if (this.removableIds.includes(related_manifest.id)) {
          related_manifest.selected = false
        }
      }
    },
    /**
     * 検索結果のうち選択済みとして保持したIDを持つマニフェストを更新する.
     */
    recheckManifests() {
      // 一覧のチェック状態を設定
      for (const manifest_id of this.selectedMembers) {
        let target = this.manifests.find((v) => v.id === manifest_id)
        if (target) {
          target.selected = true
        }
      }
    },
    categoryClick(item) {

      if (this.forms.disposal_category_codes.includes(item.value)) {
        this.forms.disposal_category_codes = this.forms.disposal_category_codes.filter(v => v !== item.value)
      } else {
        this.forms.disposal_category_codes.push(item.value)
      }
      this.afterDisposalItemCategoryChange();
    },
    subcategoryClick (item) {
      if (this.forms.disposal_subcategory_ids.includes(item.value)) {
        this.forms.disposal_subcategory_ids = this.forms.disposal_subcategory_ids.filter(v => v !== item.value)
      } else {
        this.forms.disposal_subcategory_ids.push(item.value)
      }
      this.searchButtonClickEvent()
    },
    isCategorySelected(item) {
      return Array.isArray(this.forms.disposal_category_codes)
        && this.forms.disposal_category_codes.includes(item.value)
    },

    isSubSelected(item) {
      return Array.isArray(this.forms.disposal_subcategory_ids)
        && this.forms.disposal_subcategory_ids.includes(item.value)
    },

    afterDisposalItemCategoryChange () {
      this.loadDisposedTypeOptions()
      this.searchButtonClickEvent()
    },

    clearAfterDisposalItemSubCategories() {
      this.forms.disposal_subcategory_ids = []
      this.searchButtonClickEvent()
    },




  }
}
</script>
